import React from "react";
import styled from "styled-components";
import { color, font } from "../templates/ui";
import AddressFieldGroup from "./AddressFieldGroup";
import FormGroup from "../atoms/FormGroup";
import InputItem from "../atoms/InputItem";
import InputWrapper from "../atoms/InputWrapper";
import InputItemWrapper from "../atoms/InputItemWrapper";
const StyledRowInputWrapper = styled(InputWrapper) `
    display: flex;
    flex-wrap: wrap;
`;
const StyledWrapperPhone = styled(InputItemWrapper) `
    width: 40%;

    @media only screen and (max-width: 500px) {
        width: 100%;
        margin-bottom: 30px;
        padding: 0;
    }
`;
const StyledWrapperEmail = styled(InputItemWrapper) `
    width: 60%;

    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`;
const StyledInputWrapperSalaryTaxNumber = styled(InputWrapper) `
    width: calc(40% - 20px);

    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`;
const StyledCompanyName = styled.div `
    color: ${color.primary.base};
    font-weight: 700;
    font-size: ${font.large};
`;
const StyledChamberOfCommerceNumber = styled.div `
    color: ${color.base.base};
`;
const StyledFormGroupTitle = styled.div `
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid ${color.gray.light};
`;
const CompanyDetails = ({ companyName, chamberOfCommerceNumber, data, fieldNamePrefix = "", onChangeHandler, errors, loading, }) => {
    return (React.createElement(FormGroup, null,
        (companyName || chamberOfCommerceNumber) && (React.createElement(StyledFormGroupTitle, null,
            companyName && (React.createElement(StyledCompanyName, null, companyName)),
            chamberOfCommerceNumber && (React.createElement(StyledChamberOfCommerceNumber, null,
                "KvK-nummer ",
                chamberOfCommerceNumber)))),
        React.createElement(AddressFieldGroup, { data: data, errors: errors, fieldNamePrefix: fieldNamePrefix, onChangeHandler: onChangeHandler, loading: loading, requiredFields: false }),
        React.createElement(StyledRowInputWrapper, null,
            React.createElement(StyledWrapperPhone, null,
                React.createElement(InputItem, { error: errors[fieldNamePrefix + "phone_number"], value: data[fieldNamePrefix + "phone_number"], onChange: onChangeHandler, name: fieldNamePrefix + "phone_number", type: "text", label: "Telefoonnummer", disabled: loading })),
            React.createElement(StyledWrapperEmail, null,
                React.createElement(InputItem, { error: errors[fieldNamePrefix + "email"], value: data[fieldNamePrefix + "email"], onChange: onChangeHandler, name: fieldNamePrefix + "email", type: "email", label: "E-mailadres", disabled: loading }))),
        React.createElement(StyledInputWrapperSalaryTaxNumber, null,
            React.createElement(InputItem, { error: errors[fieldNamePrefix + "income_tax_number"], value: data[fieldNamePrefix + "income_tax_number"], onChange: onChangeHandler, name: fieldNamePrefix + "income_tax_number", type: "text", label: "Loonbelastingnummer", disabled: loading }))));
};
export default CompanyDetails;
